import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DataTable from 'components/DataTable'
import React, { useCallback, useEffect, useState } from 'react'
import _ from 'lodash'
import { Form } from 'react-final-form';
import TextInput from '../input/TextInput';
import { DefaultColumnActions } from './DefaultColumnActions';
import DefaultDeleteDialog from './DefaultDeleteDialog';

function FormFilter(props) {
    const { setFilteredValues, valuesList, columns } = props
    let filtersR = props.values
    // console.log('filtersR', filtersR)
    const doFilter = useCallback((filters, valuesFiltrar) => {
        // console.log('filters', filters)
        const compareValues = (v, f) => {
            if (typeof f === 'string' || f instanceof String) {
                // console.log("V", v)
                // console.log("f", f)
                // .toString() p/ corrigir erro: v.toUpperCase() is not a function
                if (v.toString().toUpperCase().includes(f.toUpperCase())) {
                    return true;
                }
            }
            return false
        }

        if (valuesFiltrar) {
            let newArray = valuesFiltrar.filter(linha => {

                for (let index = 0; index < columns.length; index++) {
                    const column = columns[index];

                    if (column.filter) {
                        let filterValue = _.get(filters, column.field)
                        if (column.filter.compare) {
                            if (!column.filter.compare(filterValue, linha, filters)) {
                                return false
                            }
                        } else {
                            if (filterValue) {
                                let compareValue = _.get(linha, column.field)
                                if (compareValue) {
                                    if (!compareValues(compareValue, filterValue, column)) {
                                        return false
                                    }

                                } else {
                                    return false
                                }
                            }
                        }
                    }

                }

                return true;
            })

            setFilteredValues(newArray)
        } else {
            setFilteredValues([])
        }
    },
        [columns, setFilteredValues],
    )
    useEffect(() => {
        // console.log('useEffect', useEffect)
        if (valuesList) {
            doFilter(filtersR, valuesList)
        } else {
            setFilteredValues([])
        }

        return () => {
            setFilteredValues([])
        }
    }, [valuesList, filtersR, doFilter, setFilteredValues])
    return <Accordion sx={{ boxShadow: 3, mb: 1 }}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
        >
            <Typography>Filtro</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {(columns || []).map((column, index) => column.filter ? <FilterConsult key={index} filters={filtersR} column={column} />
                : "")}
        </AccordionDetails>
    </Accordion>
}

function FilterConsult(props) {
    const { column } = props
    const filter = column.filter
    // const value = _.get(filters, column.field)
    // const onChange = (v) => {
    //     setFilters(old => {
    //         let newV = { ...old }
    //         _.set(newV, column.field, v)
    //         return newV;
    //     })
    // }

    if (filter.render) {
        return <>{filter.render(props)}</>
    }

    return <TextInput name={column.field} label={column.headerName} sx={{ width: "100%", my: 1 }} />


}

export default function DefaultConsultView({
    columns,
    values,
    onRowClick,
    initialFilters,
    onFilteredValues,
    showEdit = false,
    showDelete = false,
    routeForm,
    EntityClass,
    entityName = "item"
}) {

    const [filteredValues, setFilteredValues] = useState(values)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [rowToDelete, setRowToDelete] = useState(null)

    // func to handle the deletion
    const handleDelete = (row) => {
        setRowToDelete(row)
        setDeleteDialogOpen(true)
    }

    // confirm delete function - it just inactivates the item
    const confirmDelete = async () => {
        if (rowToDelete && EntityClass) {
            try {
                const entity = new EntityClass()
                entity.update({ uid: rowToDelete.uid, status: 'INATIVO' })
                await entity.save()
                console.log(`${entityName} inativado com sucesso`)

                const updatedValues = values.filter(item => item.uid !== rowToDelete.uid)
                setFilteredValues(updatedValues.filter(item => {
                    return true
                }))
            } catch (error) {
                console.error(`Erro ao inativar ${entityName}:`, error)
            }
        }
        setRowToDelete(null)
    }

    // create the colmns if needed
    const enhancedColumns = React.useMemo(() => {
        if (!showEdit && !showDelete) {
            return columns
        }

        const actionsColumn = {
            field: "COL_ACTIONS",
            headerName: "Ações",
            flex: 0.5,
            renderCellValue: (row) => (
                <DefaultColumnActions
                    row={row}
                    routeForm={routeForm}
                    onDelete={handleDelete}
                    showEdit={showEdit}
                    showDelete={showDelete}
                />
            )
        }

        return [actionsColumn, ...columns]
    }, [columns, showEdit, showDelete, routeForm])

    useEffect(() => {
        if (filteredValues && onFilteredValues) {
            onFilteredValues(filteredValues)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = () => {
        console.log('handleSubmit', handleSubmit)
    }
    const initialValues = initialFilters || {}

    return (
        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <Box sx={{ textAlign: "center", mt: 0 }}>
                <Form onSubmit={handleSubmit} initialValues={initialValues} >
                    {(formProps) => {
                        return (
                            <form onSubmit={formProps.handleSubmit}>
                                <FormFilter setFilteredValues={setFilteredValues} valuesList={values} columns={enhancedColumns}{...formProps} />
                            </form>
                        );
                    }}
                </Form>

            </Box>

            <DataTable
                columns={enhancedColumns}
                rows={filteredValues || []}
                onRowClick={onRowClick}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            />

            <DefaultDeleteDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                onConfirm={confirmDelete}
                entityName={entityName}
            />
        </Box>
    )
}
